module.exports = __webpack_public_path__ + "static/media/default_coop.75216f3a.jpg";